export const EntityType = [
    /**
     * @description main indicator value 主指标名
     * @example DAU
     * */
    'metric_name',
    /**
     * @description main indicator name 主指标值
     * @example 1.23 million
     * */
    'metric_value',
    /**
     * @description other indicator value 其他指标值
     * @example
     * */
    'other_metric_value',
    /**
     * @description contribution ratio 贡献度
     * @example 23%
     * */
    'contribute_ratio',
    /**
     * @description delate value 变化值
     * @example -1.2
     * */
    'delta_value',
    /**
     * @description ratio value 变化率
     * @example +23%
     * */
    'ratio_value',
    /**
     * @description trend description 趋势描述
     * @example up/down
     * */
    'trend_desc',
    /**
     * @description dimension value 维值
     * @example sex = man
     * */
    'dim_value',
    /**
     * @description time description 时间描述
     * @example 2021-11-19
     * */
    'time_desc',
    /**
     * @description proportion 占比
     * @example 20%
     * */
    'proportion',
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGhyYXNlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3NjaGVtYS9waHJhc2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBNEJBLE1BQU0sQ0FBQyxNQUFNLFVBQVUsR0FBRztJQUN4Qjs7O1NBR0s7SUFDTCxhQUFhO0lBQ2I7OztTQUdLO0lBQ0wsY0FBYztJQUNkOzs7U0FHSztJQUNMLG9CQUFvQjtJQUNwQjs7O1NBR0s7SUFDTCxrQkFBa0I7SUFDbEI7OztTQUdLO0lBQ0wsYUFBYTtJQUNiOzs7U0FHSztJQUNMLGFBQWE7SUFDYjs7O1NBR0s7SUFDTCxZQUFZO0lBQ1o7OztTQUdLO0lBQ0wsV0FBVztJQUNYOzs7U0FHSztJQUNMLFdBQVc7SUFDWDs7O1NBR0s7SUFDTCxZQUFZO0NBQ0osQ0FBQyJ9